import React, { useState,Component } from 'react';
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import com_logo from "../Home/Home_modules/Im/com_logo.png";
import "../Home/Navbar_module/navbar.css";
import Mobilemenu from '../Home/Navbar_module/Mobile-menu'
import MaterialNav from './MaterialNav';
import Logout from './logout'
import MobileUserMenu from './MobileUserMenu'
import firebase from '@firebase/app-compat';
import firebaseConfig from '../fire.js';
import { getAuth } from "firebase/auth";
import 'firebase/compat/storage';
import axios from "axios";

 class LoggedinMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            notificationCount : '',
        }
        this.notificationPopupOpen = this.notificationPopupOpen.bind(this);
        this.notificationPopupClose = this.notificationPopupClose.bind(this);
        this.notificationRead = this.notificationRead.bind(this);
    }


  //  const [buttonPopUp, setButtonPopUp] = useState(false)
    notificationPopupOpen(){
        document.querySelector('.notification-container-lg').classList.add('notification-container-lg-active')
    }
    notificationPopupClose(){
        document.querySelector('.notification-container-lg').classList.remove('notification-container-lg-active')
    }
    notificationRead(notificationId){
        const notBox = document.getElementById(notificationId);
        notBox.style.opacity = 0.5;
        notBox.classList.add('notification-item-read');
        const notificationReadAPI = 'https://us-central1-diginoor-3755e.cloudfunctions.net/app/notifications/update'
        fetch(notificationReadAPI,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
                id: notificationId,
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            this.setState({notificationCount: this.state.notificationCount - 1})
        }
        )
        .catch(err => console.log(err))
    }
    
    

    
    
    componentDidMount(){
        const userUid = getAuth().currentUser.uid;
        const notificationUrl = `https://us-central1-diginoor-3755e.cloudfunctions.net/app/notifications/user/?uid=${userUid}`;
        fetch(notificationUrl,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',

                }   
            })
        .then(res => res.json())
        .then(data => {
           // console.log(data);
            this.setState({notifications: data.notifications})
            const length = data.notifications.filter(function(item){
                return item.read == false;
              }).length;
              
            this.setState({notificationCount: length})
        }
        )
        .catch(err => console.log(err))
    }
    render(){
    return (
        <>
        <div className="nav-container">
        <nav className="nav-full">
        <div className="nav">

            <div>
                <ul>
                    <li><Link to="/"><img className="com-logo" src={com_logo} alt="Logo" /></Link></li>
                </ul>
            </div>
            <div className="list">
                <ul  >
                    <li className='li' ><Link to="/collections">COLLECTIONS</Link></li>
                    <li className='li ' ><Link to="/marketplace">MARKETPLACE</Link></li>
                    <li className='li ' ><Link to="/how it works">HOW IT WORKS</Link></li>
                    <li className='li' ><Link to="/blog">BLOG</Link></li>
                    <li className='li'><Link to="/about">ABOUT</Link></li>
                    {/* <li className='li'><i class='fas fa-wallet' id="wal-ic1" ></i></li> */}
                    <li className='li'><Link to="/wallet"><i class='fas fa-wallet' id="wal-ic" ></i></Link></li>
                    <li className="li">
                        <div className='notification-menu'>
                            <button onClick={this.notificationPopupOpen} className='notification-bell'>
                                <i class="fas fa-bell"></i>
                                <span className='notification-count'>{this.state.notificationCount}</span>
                            </button>
                        </div>
                    </li>
                    {/* <button className="mob">btn</button> */}
                </ul>
                <div className="ton">
                    {/* <label className="toggleSwitch nolabel">
                        <input type="checkbox" checked />
                        <a></a>
                        <span  >
                            <span className="left-span" ><Link to="/about">Login</Link></span>
                            <span className="right-span" ><Link to="/signup">signup</Link></span>
                        </span>
                    </label> */}
                    <div className="menu-dropdown">
  <button className="dropbtn"><i className="fas fa-user"></i></button>
  <div className="dropdown-content" >
  <p><Link to="/profile">Profile</Link></p>
  <p><Logout></Logout></p>
  </div>
</div>


                   {/*  <div className="log-btt">
                   <p className="log-btt-text"><Link to="/login">Profile</Link></p>
                    </div>
                    <div className="signup-btt">
                    <p  className="log-btt-text-signup"><Link to="/profile">Settings</Link></p>
                </div> 
*/}
                </div>
            </div>
        </div>
    </nav>
    <div className="mobile-menu">
    <MobileUserMenu />
    </div>
    
    </div>
    <div className="notification-container-lg">
        <div className="notification-box">
            <div className="notification-box-header">
                <h3>Notifications</h3>
                <button className="notification-close" onClick={this.notificationPopupClose}>x</button>
            </div>
                <div className='notification-list'>
                   {this.state.notifications.map(notification => {

                        return (
                            <div id={`${notification._id}`} onClick={() => {this.notificationRead(notification._id)} } 
                            className={
                                notification.read == false ? `notification-list-item ${notification._id}` 
                                : `notification-list-item ${notification._id} notification-item-read`}>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>{notification.text}</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>{notification.date}</p>
                           {/* <p>few minutes ago</p> */}
                        </div>
                    </div>
                        )
                   })}
                </div>
        </div>
    </div>
    </>
    )
}
    
}


export default LoggedinMenu;

    